export const UNIT_SOURCE_ID = "2023-09-05T17-36-16Z-5ce7ce";
export const CURRENT_LESSON_INDEX_KEY = "cli";
export const CURRENT_TOKEN_KEY = "auth_token";
export const CURRENT_PUBLICATIONID_KEY = "publicationid";
export const CURRENT_UNITID_KEY = "unitid";
export const PUBLICATION_ID = "2024-02-19T17-38-19Z-28b686";
export const UNIT_ID = "2024-02-19T16-46-40Z-6ff641";
export const MOBILE_WIDTH = 1024;
export const DEFAULT_BASE_URL ="https://edtech.rwb.ru/lms/ru";
export const TEST_SHOW_RESULT_FLAG = "checked";
